import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Color } from '~app/shared/enums/color.enum';
import { Icon } from '~app/shared/enums/icon.enum';
import { ModalService } from '~app/shared/services/modal/modal.service';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorModalComponent {
  public Icon = Icon;
  public Color = Color;
  constructor(private readonly modal: ModalService) {}

  public closeModal(): void {
    this.modal.close();
  }
}
